import { Box, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";
import whoWeAreImage from "../../assets/dubai-buy.jpg";

export default function WhoWeAre() {
  return (
    // <Box
    //   sx={{
    //     py: { xs: 12, md: 18 },
    //     backgroundColor: "var(--color-primary-dark)",
    //     position: "relative",
    //     overflow: "hidden",
    //   }}
    // >
    <Box
      sx={{
        py: { xs: 3, md: 6 },
        backgroundColor: "var(--color-bg)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1.05fr 0.95fr" },
            gap: { xs: 6, md: 12 },
            alignItems: "center",
          }}
        >
          {/* LEFT CONTENT */}
          <motion.div
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.85 }}
            viewport={{ once: true }}
          >
            {/* EYEBROW */}
            <Typography
              sx={{
                letterSpacing: "0.26em",
                fontSize: 12,
                fontWeight: 600,
                color: "var(--color-gold)",
                mb: 3,
              }}
            >
              WHO WE ARE
            </Typography>

            {/* TWO-COLOR HEADING */}
            <Typography
              sx={{
                fontSize: {
                  xs: "2.1rem",
                  sm: "2.6rem",
                  md: "3.1rem",
                  lg: "3.4rem",
                },
                fontWeight: 600,
                lineHeight: 1.12,
                maxWidth: 680,
                mb: 3,
              }}
            >
              <Box component="span" sx={{ color: "var(--color-text-primary)" }}>
                A Luxury Real Estate Partner
              </Box>

              <br />
              <Box
                component="span"
                sx={{
                  color: "var(--color-gold)",
                  borderBottom: "2px solid var(--color-gold)",
                  paddingBottom: "4px",
                  display: "inline-block",
                }}
              >
                Built on Trust & Expertise
              </Box>
            </Typography>

            {/* CONTENT FRAME */}
            <Box
              sx={{
                pl: { xs: 0, md: 3 },
                borderLeft: {
                  xs: "none",
                  md: "1px solid rgba(207,172,106,0.45)",
                },

                // borderLeft: {
                //   xs: "none",
                //   md: "1px solid rgba(207,172,106,0.35)",
                // },
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: 14, md: 16 },
                  lineHeight: 1.9,
                  // color: "rgba(255,255,255,0.8)",
                  color: "var(--color-text-muted)",

                  mb: 3,
                  maxWidth: 620,
                }}
              >
                Vision X Nexus is a luxury real estate agency delivering refined
                property experiences across the UAE. We work with discerning
                buyers, sellers, and investors who value confidence, discretion,
                and long-term value.
              </Typography>

              <Typography
                sx={{
                  fontSize: { xs: 14, md: 16 },
                  lineHeight: 1.9,
                  // color: "rgba(255,255,255,0.8)",
                  color: "var(--color-text-muted)",
                  mb: 4,
                  maxWidth: 620,
                }}
              >
                Guided by market insight and a client-first philosophy, our team
                offers tailored guidance at every stage of the real estate
                journey — ensuring informed decisions and seamless outcomes.
              </Typography>
            </Box>

            {/* TRUST LINE */}
            <Typography
              sx={{
                letterSpacing: "0.2em",
                fontSize: 12,
                fontWeight: 600,
                color: "var(--color-gold)",
                mt: 2,
              }}
            >
              TRUST • INTEGRITY • MARKET EXPERTISE
            </Typography>
          </motion.div>

          {/* RIGHT IMAGE */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.9 }}
            viewport={{ once: true }}
          >
            <Box
              sx={{
                position: "relative",
                borderRadius: 4,
                overflow: "hidden",
                height: { xs: 340, md: 540 },
                // boxShadow: "0 35px 80px rgba(0,0,0,0.22)",
              }}
            >
              {/* <Box
              sx={{
                position: "relative",
                borderRadius: 4,
                overflow: "hidden",
                boxShadow: "0 50px 110px rgba(0,0,0,0.75)",
              }}
            > */}
              <Box
                component="img"
                src={whoWeAreImage}
                alt="Vision X Nexus UAE Real Estate"
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />

              {/* DARK OVERLAY */}
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "linear-gradient(180deg, rgba(255,255,255,0.05), rgba(0,0,0,0.25))",
                }}
              />

              {/* <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "linear-gradient(180deg, rgba(0,0,0,0.15), rgba(0,0,0,0.55))",
                }}
              /> */}

              {/* GOLD FRAME */}
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  border: "1px solid rgba(207,172,106,0.45)",
                  borderRadius: 4,
                  pointerEvents: "none",
                }}
              />
            </Box>
          </motion.div>
        </Box>
      </Container>
      {/* BOTTOM GOLD LINE */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: "5%",
          right: "5%",
          height: "1px",
          background:
            "linear-gradient(90deg, transparent, var(--color-gold), transparent)",
          opacity: 0.6,
        }}
      />
    </Box>
  );
}
